import Vue from "vue";
import Component from "vue-class-component";

@Component
export class RandomId extends Vue {
  dec2hex(dec): string {
    return dec.toString(16).padStart(2, "0");
  }
  generateId(len): string {
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2hex).join("");
  }
}
